import CreatePaymentContainer from './AmazonCrossCheck.container'

export default CreatePaymentContainer;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Payments/AmazonCrossCheck/index.js